import { IBaseOWClassDescription, IPublicAttributeInfo, OWAttributeDesciption } from "@multiweb/types/contracts";
import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";

/**
 * Vrací informace o modelu
 */
export interface IModelDescriptionsManager {
    /**
     * Vrací popisnou třídu daného objektu
     */
    getClassInfo(className: string, cancelationToken?: CancellationToken): Promise<IOWClassDescription>;
    /**
     * Vrací informace o atributech přiřazených k dané třídě
     * @param className Název třídy
     * @param attributes Seznam atributu
     * @param cancelationToken rušící token
     */
    getAttributesInfo(className: string, attributes: ReadonlyArray<string>, cancelationToken?: CancellationToken): Promise<ReadonlyArray<IPublicAttributeInfo>>;
    /**
     * Vrací informace o konkrétním atributu přiřazeném k dané třídě
     * @param className Název třídy
     * @param attribute Název atributu
     * @param cancelationToken rušící token
     */
    getAttributeInfo(className: string, attribute: string, cancelationToken?: CancellationToken): Promise<IPublicAttributeInfo>;
    /**
     * Pročistí cache popisů tříd a atributů
     */
    clearCache(): void;
}

export class IModelDescriptionsManager {
    private static _properties: (keyof(IModelDescriptionsManager))[] = [];
    private static _methods: (keyof(IModelDescriptionsManager))[] = ["getClassInfo", "getAttributesInfo", "clearCache"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}

/**
 * Základní typy
 */
export enum BasicDataType { Unknown, String, BasicNumber, BigNumber, Enum, StrNum, DateTime, Boolean, Color, OWObject, Binary, Document, OWObjectList }

/**
 * Interface popisné třídy
 */
export interface IOWClassDescription extends IBaseOWClassDescription {

    /**
     * Vrátí základní informace o atributu
     * @param attrName Název atributu, může být i s vazbou či přetypováním
     */
    getAttributeInfo(attrName: string): Promise<AttributeDescription>;
}

/**
 * Popis konkrétního datového typu
 */
export interface IDataTypeDescription {
    attrName: string;
    basicType: BasicDataType;
    /** Výchozí hodnota nenaplněného atributu */
    defaultValue: any;
    serverType?: string;
}

/**
 * Popis serializátoru konkrétního datového typu
 */
export interface IDataTypeSerialization {
    deserializer?: (value: any) => any;
    serializer?: (value: any, oldValue: any) => any;
}

export type AttributeDescription = OWAttributeDesciption & {
    /**
     * Základní typ
     */
    basicType: BasicDataType;
    /**
     * Výchozí hodnota nenaplněného atributu
    */
    defaultValue: any;
};
